import React from "react";
import Link from "../global/Link";

export const FooterBotMenu = ({menu}) => {

  return menu?.length > 0 && menu.map((item, index) => (
      <Link key={index} className="me-lg-6 mb-2 mb-md-0 me-3 fs-7" target={item.target} to={item.url}>{item.label}</Link>
    )
  )
}
